import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as mainActions from '../../actions/mainActions';
import { Grid, Button, IconButton } from 'material-ui';
import ArrowBack from 'material-ui-icons/ArrowBack';
import { bHistory } from '../../containers/AppRouter';
import { SATISFACTION } from '../../config/constants';
import imgRating2Inactive from '../../resources/images/rating-2-inactive.png';
import imgRating4Inactive from '../../resources/images/rating-4-inactive.png';
import imgRating5Inactive from '../../resources/images/rating-5-inactive.png';
import imgRating2 from '../../resources/images/rating-2.png';
import imgRating4 from '../../resources/images/rating-4.png';
import imgRating5 from '../../resources/images/rating-5.png';
import { saveSurveys } from '../../controllers/surveys';
import moment from 'moment';
import { Save } from '@material-ui/icons';
import { requestSurvey } from '../../controllers/surveys';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../App.css';
import DateTimePickerCustom from '../displayComponents/DateTimePickerCustom';
import SelectComponent from '../displayComponents/SelectComponent';

class Satisfation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            enquisa: {
                survey_date: moment().format('DD/MM/YYYY HH:mm:ss'),
                office_id: -1,
                municipality_id: -1
            },
            surveyDisabled: false
        };
    }

    componentDidMount() {
        const { sessionData } = this.props.main;

        const id = parseInt(this.props.id, 10);
        if (id) {
            this.loadSurvey(id);
            this.setState({ surveyDisabled: true });
        } else {
            if (sessionData.municipality){
                this.setState({ enquisa: { ...this.state.enquisa,  municipality_id: sessionData.municipality, office_id: sessionData.office} })
            }
        }
    }

    setValue = (question, value) => {
        const { enquisa } = this.state;
        enquisa[question] = value;
        this.setState({ enquisa });
    }

    loadSurvey = async (id) => {
        try {
            const { sessionData } = this.props.main;
            let survey = await requestSurvey(sessionData.userName, sessionData.passwd, { type: 'satisfaction', id: id });
            this.setState({ enquisa: survey.result.data[0] });
        } catch (err) {
            console.error(err);
        }
    }

    saveSurvey = async () => {
        const { sessionData } = this.props.main;

        try {
            let { enquisa } = this.state;
            for (let i = 0; i < SATISFACTION.length; i++) {
                if (!enquisa[SATISFACTION[i].field]) return toast("Faltan preguntas por cubrir", { autoClose: 50000, className: "toast-error" });
            }
            enquisa.terminal_id = this.props.main.terminal_id;
            const data = {
                username: sessionData.userName,
                passwd: sessionData.passwd,
                terminal_id: sessionData.terminal_id,
                satisfactionSurveys: [enquisa]
            }
            let response = await saveSurveys(data);
            if (response.code === 200) toast("Enquisa gardada correctamente", { autoClose: 3000, className: "toast-success" });
            else {
                console.error(response);
                return toast("Produciuse un erro ao gardar a enquisa", { autoClose: 3000, className: "toast-error" });
            }
            let updatedData = {
                survey_date: enquisa.survey_date,
                office_id: enquisa.office_id,
                municipality_id: enquisa.municipality_id
            }
            this.setState({ enquisa: updatedData }, () => {
                this.props.refresh();
                this.props.close();
            });
        } catch (err) {
            console.error(err);
        }
    }

    setDate = (date) => {
        let { enquisa } = this.state;
        enquisa.survey_date = date.format('DD/MM/YYYY HH:mm:ss');
        this.setState({ enquisa });
    }

    render() {
        const { enquisa, surveyDisabled } = this.state;
        const { iconBack, imgRating, questionTitle, gridRating, iconRating, header, iconSave, gridQuestion, gridHeader } = customStyles;
        const { municipalities, offices, sessionData } = this.props.main;
        const { close } = this.props;
        const id = parseInt(this.props.id, 10);
        return (
            <Fragment>
                <Grid container justify="center">
                    <Grid item style={header} xs={12}>
                        <Grid container justify="center" alignItems="center" style={gridHeader}>
                            <Grid item xs={2}>
                                <Button size="large" style={{
                                    backgroundColor: "#DDD",
                                    marginTop: '0.5em',
                                    marginLeft: '0'
                                }} onClick={() => close()}><ArrowBack style={iconBack} />Voltar</Button>
                            </Grid>
                            <Fragment>
                                <Grid item style={gridQuestion} xs={6}></Grid>
                                <Grid item style={gridQuestion} xs={4}>
                                    <p>Usuario: <b>{sessionData.name}</b></p>
                                </Grid>
                            </Fragment>
                        </Grid>
                        <Grid style={gridQuestion} item xs={12}>
                            <DateTimePickerCustom
                                disabled={surveyDisabled}
                                label="Data da enquisa"
                                value={enquisa.survey_date}
                                format="DD/MM/YYYY HH:mm:ss"
                                displayFormat="LLL"
                                setDate={this.setDate}
                            />
                            <SelectComponent
                                disabled={surveyDisabled || sessionData.municipality}
                                label="Concello"
                                defaultValue="Todos"
                                items={municipalities}
                                value={enquisa.municipality_id}
                                fieldValue="id"
                                fieldName="name"
                                name="municipality_id"
                                setValue={event => { this.setValue('municipality_id', event.target.value) }} />
                            <SelectComponent
                                disabled={surveyDisabled}
                                label="Oficina"
                                defaultValue="Todas"
                                items={(!!enquisa.municipality_id && enquisa.municipality_id != -1) ? offices.filter((office) => { return office.municipality_id === enquisa.municipality_id }) : offices}
                                value={enquisa.office_id}
                                fieldValue="id"
                                fieldName="name"
                                name="office_id"
                                setValue={event => { this.setValue('office_id', event.target.value) }} />
                        </Grid>
                    </Grid>
                    {SATISFACTION.map((question) => {
                        return (
                            <Grid key={`ratgin_${question.id}`} lg={3} item>
                                <p style={questionTitle}>{question.question}</p>
                                <Grid style={gridRating} item xs={12}>
                                    <IconButton style={iconRating} disabled={surveyDisabled} onClick={() => { this.setValue(question.field, 2) }}>
                                        <img style={imgRating} src={enquisa[question.field] === 2 ? imgRating2 : imgRating2Inactive} alt="Mal" />
                                    </IconButton>
                                    <IconButton style={iconRating} disabled={surveyDisabled} onClick={() => { this.setValue(question.field, 4) }}>
                                        <img style={imgRating} src={enquisa[question.field] === 4 ? imgRating4 : imgRating4Inactive} alt="Regular" />
                                    </IconButton>
                                    <IconButton style={iconRating} disabled={surveyDisabled} onClick={() => { this.setValue(question.field, 5) }}>
                                        <img style={imgRating} src={enquisa[question.field] === 5 ? imgRating5 : imgRating5Inactive} alt="Ben" />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
                {!id &&
                    <Grid item xs={12}>
                        <Button style={{ float: 'right' }} size="large" variant="raised" color="secondary" onClick={this.saveSurvey}>
                            <Save style={iconSave} />Gardar</Button>
                    </Grid>
                }
            </Fragment>
        );
    }
}

const customStyles = {
    iconBack: {
        fontSize: "1.15rem",
        marginRight: "0.5rem"
    },
    imgRating: {
        width: "100%",
    },
    questionTitle: {
        textAlign: "center",
        fontWeight: "bold"
    },
    gridRating: {
        textAlign: "center",
        paddingBottom: "2rem"
    },
    iconRating: {
        margin: "0.5rem",
        width: "4rem",
        height: "4rem"
    },
    header: {
        marginBottom: "3rem"
    },
    iconSave: {
        fontSize: "1.3rem",
        paddingRight: "0.3rem"
    },
    gridQuestion: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    gridHeader: {
        marginBottom: "2rem"
    }
}

const mapStateToProps = (state) => ({
    main: state.main
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Satisfation);


// WEBPACK FOOTER //
// ./src/components/Satisfations/Satisfation.js